<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <b-card id="navbar" no-body>
      <b-tabs
        pills
        card
        v-model="tabIndex"
        class="no-padding"
        active-tab-class="nav-basic"
        active-nav-item-class="nav-active"
      >
        <b-tab slot="tabs-end" title="Visão geral" active />
        <b-tab slot="tabs-end" title="Segmentação" />
      </b-tabs>
    </b-card>
    <b-card no-body>
      <b-tabs pills card>
        <b-tab title="Filtros">
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="12">
              <b-input-group prepend="Data Inicial" class="date-input">
                <datepicker
                  class="form-control"
                  placeholder="Escolha a data"
                  v-model="datainicial"
                  :language="ptBR"
                  :format="customFormatter"
                  :disabledDates="disabledDatesStart"
                  :key="disabledDatesStart != null"
                  @selected="mudaDataInicial"
                ></datepicker>
              </b-input-group>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12">
              <b-input-group prepend="Data Final" class="date-input">
                <datepicker
                  class="form-control"
                  placeholder="Escolha a data"
                  v-model="datafinal"
                  :language="ptBR"
                  :format="customFormatter"
                  @selected="mudaDataFinal"
                  :disabledDates="disabledDatesEnd"
                  :key="disabledDatesEnd != null"
                ></datepicker>
              </b-input-group>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-card v-if="tabIndex == 0">
      <div>
        <apexchart
          type="area"
          height="350"
          :options="chartOptions"
          :series="series_diarios"
        />
      </div>
    </b-card>

    <b-card v-if="tabIndex == 1">
      <div>
        <b-row>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-danger">
              <b-card-body class="pb-0">
                <h4 class="mb-0">R$ {{ custo_totalizado }}</h4>
                <p>
                  <strong>Custo</strong>
                </p>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-primary">
              <b-card-body class="pb-0">
                <h4 class="mb-0">R$ {{ venda_totalizado }}</h4>
                <p>
                  <strong>Venda</strong>
                </p>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-success">
              <b-card-body class="pb-0">
                <h4 class="mb-0">R$ {{ lucro_totalizado }}</h4>
                <p>
                  <strong>Lucro</strong>
                </p>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-info">
              <b-card-body class="pb-0">
                <h4 class="mb-0">{{ perclucro_totalizado }}</h4>
                <p>
                  <strong>Percentual Lucro</strong>
                </p>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="6">
            <segmentacao
              titulo="Setores"
              url="setor"
              :categories="categoriesSetor"
              :series="seriesSetor"
            />
          </b-col>
          <b-col cols="6">
            <segmentacao
              titulo="Marcas"
              url="marca"
              :categories="categoriesMarca"
              :series="seriesMarca"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <segmentacao
              titulo="Grupos"
              url="grupo"
              :categories="categoriesGrupo"
              :series="seriesGrupo"
            />
          </b-col>
          <b-col cols="6">
            <segmentacao
              titulo="Produtos"
              url="produto"
              :categories="categoriesProduto"
              :series="seriesProduto"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import axios from "axios";
import * as config from "@/config.json";
import Loading from "vue-loading-overlay";

import Segmentacao from "./components/Segmentacao.vue";
import moment from "moment";

export default {
  components: {
    Datepicker,
    Loading,
    Segmentacao,
    moment,
  },
  data: () => {
    return {
      datainicial: null,
      datafinal: null,
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      isLoading: false,
      tabIndex: 0,
      custo_totalizado: null,
      venda_totalizado: null,
      lucro_totalizado: null,
      perclucro_totalizado: null,
      clientes_ativos: null,
      clientes_inativos: null,
      labels_diarios: null,
      series_diarios: [],

      chartOptions: {
        height: 350,
        type: "area",
        events: {
          selection: function (chart, e) {
            console.log(new Date(e.xaxis.min));
          },
        },
        colors: ["#f5d142", "#008FFB", "#00E396"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        fill: {
          type: "gradient",
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
        xaxis: {
          type: "datetime",
          labels: {
            formatter: function (value, timestamp) {
              return moment(timestamp).format("DD/MM"); // The formatter function overrides format property
            },
          },
        },
      },
      series_cadastro: [
        {
          data: [],
        },
      ],
      options_cadastro: {
        chart: {
          height: 350,
          type: "bar",
        },
        colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560"],
        plotOptions: {
          bar: {
            columnWidth: "10%",
            endingShape: "rounded",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ["Péssimo", "Ruim", "Bom", "Exclente"],
          labels: {
            style: {
              colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560"],
              fontSize: "14px",
            },
          },
        },
      },
      seriesSetor: [],
      categoriesSetor: [],
      seriesMarca: [],
      categoriesMarca: [],
      seriesGrupo: [],
      categoriesGrupo: [],
      categoriesProduto: [],
      seriesProduto: [],
      series_donut: [],
      options_donut: {
        labels: [],
        plotOptions: {
          donut: {
            size: "65%",
            background: "transparent",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "22px",
                fontFamily: "Helvetica, Arial, sans-serif",
                color: undefined,
                offsetY: -10,
              },
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200,
                    },
                    legend: {
                      position: "bottom",
                    },
                  },
                },
              ],
            },
          },
        },
      },
      series_bar: [
        {
          name: "Informação",
          data: [],
        },
      ],
      options_bar: {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "25%",
            endingShape: "flat",
          },
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#775DD0",
            shadeTo: "light",
            shadeIntensity: 0.5,
          },
        },
        dataLabels: {
          enabled: false,
        },
      },
    };
  },
  methods: {
    generateTimestampData(labels, array) {
      var arr = [];
      for (let i = 0; i < labels.length; i++) {
        const e = labels[i];
        let data = moment(e).add(1, "days");
        arr.push([new Date(data).getTime(), array[i]]);
      }
      return arr;
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async mudaDataFinal(data) {
      if (data) {
        localStorage.setItem("datafinal_analise", this.formatEndDate(data));
        this.disabledDatesStart = null;
        this.disabledDatesStart = {};
        this.disabledDatesStart.from = new Date(data);
        this.isLoading = true;
        await this.getTotais();
        await this.getSegmentacao();
        this.isLoading = false;
      }
    },
    async mudaDataInicial(data) {
      if (data) {
        localStorage.setItem("datainicial_analise", this.formatStartDate(data));
        this.disabledDatesEnd = null;
        this.disabledDatesEnd = {};
        this.disabledDatesEnd.to = new Date(data);
        this.disabledDatesEnd.from = new Date();
        this.isLoading = true;
        await this.getTotais();
        await this.getSegmentacao();
        this.isLoading = false;
      }
    },

    formatStartDate(date) {
      return moment(date).format("YYYY-MM-DD 00:00:00");
    },

    formatEndDate(date) {
      return moment(date).format("YYYY-MM-DD 23:59:59");
    },

    async receberTotalizadores() {
      const url = `${
        config.default.servidor
      }/gerencial/vendas-totais/${this.formatStartDate(
        this.datainicial
      )}/${this.formatEndDate(this.datafinal)}/${localStorage.getItem(
        "enterprise_id"
      )}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        console.log({response});

        if (response.status == 200) {
          this.custo_totalizado = Number(
            response.data.data.custo.toFixed(2)
          ).toLocaleString("pt-BR");
          this.venda_totalizado = Number(
            response.data.data.venda.toFixed(2)
          ).toLocaleString("pt-BR");
          this.lucro_totalizado = Number(
            response.data.data.lucro.toFixed(2)
          ).toLocaleString("pt-BR");
          this.perclucro_totalizado = response.data.data.percLucro;
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async receberBaseClientes() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/clientes/${localStorage.getItem(
            "enterprise_id"
          )}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw==",
            },
          }
        )
        .then((response) => {
          if (response.status == 200) {
            this.clientes_ativos = response.data.data.clientes_ativos;
            this.clientes_inativos = response.data.data.clientes_inativos;
          }
        });
    },

    async receberSetores() {
      const url = `${
        config.default.servidor
      }/gerencial/vendas-por-setor/${this.formatStartDate(
        this.datainicial
      )}/${this.formatEndDate(this.datafinal)}/${localStorage.getItem(
        "enterprise_id"
      )}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.categoriesSetor = [];
          this.seriesSetor = [];
          var arrVenda = [];
          var arrLucro = [];

          response.data.data = response.data.data.sort((a, b) => {
            if (a.TotalVenda < b.TotalVenda) return 1;
            else if (a.TotalVenda > b.TotalVenda) return -1;
            else return 0;
          });

          for (let i = 0; i < response.data.data.length; i++) {
            if (i > 5) break;
            const e = response.data.data[i];
            console.info({ e });
            this.categoriesSetor.push(e.Descricao);
            arrVenda.push(parseFloat(e.TotalVenda).toFixed(2));
            arrLucro.push(
              (
                parseFloat(e.TotalVenda).toFixed(2) -
                parseFloat(e.TotalCusto).toFixed(2)
              ).toFixed(2)
            );
          }
          this.seriesSetor.push(
            {
              name: "Venda total",
              type: "column",
              data: arrVenda,
            },
            {
              name: "Lucro total",
              type: "line",
              data: arrLucro,
            }
          );
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async receberMarcas() {
      const url = `${
        config.default.servidor
      }/gerencial/vendas-por-marca/${this.formatStartDate(
        this.datainicial
      )}/${this.formatEndDate(this.datafinal)}/${localStorage.getItem(
        "enterprise_id"
      )}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.categoriesMarca = [];
          this.seriesMarca = [];
          var arrVenda = [];
          var arrLucro = [];
          response.data.data = response.data.data.sort((a, b) => {
            if (a.TotalVenda < b.TotalVenda) return 1;
            else if (a.TotalVenda > b.TotalVenda) return -1;
            else return 0;
          });
          for (let i = 0; i < response.data.data.length; i++) {
            if (i > 5) break;
            const e = response.data.data[i];
            this.categoriesMarca.push(e.Descricao);
            arrVenda.push(parseFloat(e.TotalVenda).toFixed(2));
            arrLucro.push(
              (
                parseFloat(e.TotalVenda).toFixed(2) -
                parseFloat(e.TotalCusto).toFixed(2)
              ).toFixed(2)
            );
          }
          this.seriesMarca.push(
            {
              name: "Venda total",
              type: "column",
              data: arrVenda,
            },
            {
              name: "Lucro total",
              type: "line",
              data: arrLucro,
            }
          );
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async receberGrupos() {
      const url = `${
        config.default.servidor
      }/gerencial/vendas-por-grupo/${this.formatStartDate(
        this.datainicial
      )}/${this.formatEndDate(this.datafinal)}/${localStorage.getItem(
        "enterprise_id"
      )}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.categoriesGrupo = [];
          this.seriesGrupo = [];
          var arrVenda = [];
          var arrLucro = [];
          response.data.data = response.data.data.sort((a, b) => {
            if (a.TotalVenda < b.TotalVenda) return 1;
            else if (a.TotalVenda > b.TotalVenda) return -1;
            else return 0;
          });
          for (let i = 0; i < response.data.data.length; i++) {
            if (i > 5) break;
            const e = response.data.data[i];
            this.categoriesGrupo.push(e.Descricao);
            arrVenda.push(parseFloat(e.TotalVenda).toFixed(2));
            arrLucro.push(
              (
                parseFloat(e.TotalVenda).toFixed(2) -
                parseFloat(e.TotalCusto).toFixed(2)
              ).toFixed(2)
            );
          }
          this.seriesGrupo.push(
            {
              name: "Venda total",
              type: "column",
              data: arrVenda,
            },
            {
              name: "Lucro total",
              type: "line",
              data: arrLucro,
            }
          );
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async receberProdutos() {
      const url = `${
        config.default.servidor
      }/gerencial/vendas-por-produto/${this.formatStartDate(
        this.datainicial
      )}/${this.formatEndDate(this.datafinal)}/${localStorage.getItem(
        "enterprise_id"
      )}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.categoriesProduto = [];
          this.seriesProduto = [];
          var arrVenda = [];
          var arrLucro = [];
          response.data.data = response.data.data.sort((a, b) => {
            if (a.totalvenda < b.totalvenda) return 1;
            else if (a.totalvenda > b.totalvenda) return -1;
            else return 0;
          });
          for (let i = 0; i < response.data.data.length; i++) {
            if (i > 4) break;
            const e = response.data.data[i];
            this.categoriesProduto.push(e.Descricao);
            arrVenda.push(parseFloat(e.totalvenda).toFixed(2));
            arrLucro.push(
              (
                parseFloat(e.totalvenda).toFixed(2) -
                parseFloat(e.totalcusto).toFixed(2)
              ).toFixed(2)
            );
          }
          this.seriesProduto.push(
            {
              name: "Venda total",
              type: "column",
              data: arrVenda,
            },
            {
              name: "Lucro total",
              type: "line",
              data: arrLucro,
            }
          );
        }
      } catch (error) {
        console.log({ error });
      }
    },

    redirecionarSetor() {
      this.$router.push("analises/setor");
    },

    redirecionarMarca() {
      this.$router.push("analises/marca");
    },

    redirecionarGrupo() {
      this.$router.push("analises/grupo");
    },

    async receberVendasDiarias() {
      const url = `${
        config.default.servidor
      }/gerencial/vendas-diarias/${this.formatStartDate(
        this.datainicial
      )}/${this.formatEndDate(this.datafinal)}/${localStorage.getItem(
        "enterprise_id"
      )}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          var custo = [];
          var lucro = [];
          var labels = [];

          for (let i = 0; i < response.data.data.length; i++) {
            const e = response.data.data[i];
            labels.push(e.data);
            custo.push(parseFloat(e.custo).toFixed(2));
            lucro.push(parseFloat(e.venda - e.custo).toFixed(2));
          }

          var custoTratado = await this.generateTimestampData(labels, custo);
          var lucroTratado = await this.generateTimestampData(labels, lucro);

          this.series_diarios = [
            {
              name: "Lucro",
              data: lucroTratado,
            },
            {
              name: "Custo",
              data: custoTratado,
            },
          ];
        }

        console.info({
          series: this.series_diarios,
          labels: this.labels_diarios,
        });
      } catch (error) {
        console.log({ error });
      }
    },

    async getTotais() {
      await this.receberVendasDiarias();
      await this.receberTotalizadores();
    },

    async getSegmentacao() {
      await this.receberSetores();
      await this.receberMarcas();
      await this.receberGrupos();
      await this.receberProdutos();
    },
  },

  async beforeMount() {
    this.isLoading = true;
    
    if (localStorage.getItem("datainicial_analise") == null) {
      this.datainicial = moment().startOf("month").format("YYYY-MM-DD HH:mm:ss");
      localStorage.setItem("datainicial_analise", this.datainicial);
    } else {
      this.datainicial = localStorage.getItem("datainicial_analise");
    }

    this.datafinal = new moment().format("YYYY-MM-DD HH:mm:ss");
    localStorage.setItem("datafinal_analise", this.datafinal);
    
    this.disabledDatesStart = {};
    this.disabledDatesStart.from = new Date(this.datafinal);

    this.disabledDatesEnd = {};
    this.disabledDatesEnd.to = new Date(this.datainicial);
    this.disabledDatesEnd.from = new Date(this.datafinal);

    await this.getTotais();
    await this.getSegmentacao();

    if (localStorage.getItem("segmentacaoTab")) {
      this.tabIndex = 1
    }

    this.isLoading = false;
  },

  destroyed() {
    localStorage.removeItem("segmentacaoTab");
  },
};
</script>
